import { Outlet } from 'react-router';
import { AdminSidebar } from '@/components/AdminSidebar';
import { OfflineNotice } from '@/components/owner-ui';
import { PageTransition } from '@/components/PageTransition';
import { AdminHeader } from '@/components/header';
import { CommandPalette } from '@/components/CommandPalette';
import { useAdminKeyboardShortcuts } from '@/hooks/useAdminKeyboardShortcuts';

export default function AdminLayout() {
  useAdminKeyboardShortcuts();

  return (
    <div className="flex min-h-screen bg-[#F7F7F8] dark:bg-background">
      <CommandPalette />
      <OfflineNotice />
      <AdminSidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <AdminHeader />
        <main className="flex-1 p-4 sm:p-6">
          <div className="mx-auto max-w-screen-2xl">
            <PageTransition>
              <Outlet />
            </PageTransition>
          </div>
        </main>
      </div>
    </div>
  );
}
